import { UserAction } from "@brookbush/types";

import { SparklesIcon } from "lucide-react";

import Button from "~/components/Button";
import useUserAction from "~/hooks/useUserAction";

const ChatSignedOut = () => {
	const { setUserAction } = useUserAction();

	return (
		<div className="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center">
			<span className="flex size-12 items-center justify-center rounded-full bg-sky-100 text-sky-600 dark:bg-sky-900/40 dark:text-sky-400">
				<SparklesIcon className="size-6" />
			</span>
			<div>
				<h2 className="font-bold text-lg text-slate-900 dark:text-white">
					Sign in to chat with the AI Tutor
				</h2>
				<p className="text-slate-500 text-sm dark:text-slate-400">
					Get instant answers about movement, anatomy, and your courses.
				</p>
			</div>
			<Button size="sm" onClick={() => setUserAction(UserAction.SIGN_IN)}>
				Sign in to chat
			</Button>
		</div>
	);
};

export default ChatSignedOut;
